import { CopyIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

import { isKeyEnter } from '@/util/util';

type Props = { name: string; value: string };

/** Read-only replay context variable: the name over its value, copyable. */
export const ReadonlyVariableRow = ({ name, value }: Props) => {
  const { t } = useTranslation();

  const handleCopy = () => {
    navigator.clipboard.writeText(value);
    toast.success(t('common.copied'));
  };

  return (
    <div
      className="group flex max-w-xl cursor-pointer items-center gap-4 self-stretch rounded-lg p-3 hover:bg-selected-soft"
      onClick={handleCopy}
      onKeyDown={(e) => {
        if (isKeyEnter(e)) {
          handleCopy();
        }
      }}
      role="button"
      tabIndex={0}
      aria-label={t('common.copy')}
    >
      <div className="flex min-w-0 flex-1 flex-col gap-0.5">
        <span className="text-sm leading-5 font-normal text-muted-foreground">{name}</span>
        <p className="text-sm leading-6 font-normal wrap-anywhere whitespace-pre-wrap text-foreground">
          {value}
        </p>
      </div>
      <CopyIcon
        size={16}
        className="invisible shrink-0 text-muted-foreground group-hover:visible"
      />
    </div>
  );
};
